import { Component } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-info-pop-up-dialog',
    standalone: true,
    imports: [
        FlexModule,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatDialogClose,
        TranslateModule,
        MatAnchor,
        NgIf,
        MatIcon,
        MatIconButton,
    ],
    templateUrl: './info-pop-up-dialog.component.html',
    styleUrl: './info-pop-up-dialog.component.scss',
})
export class InfoPopUpDialogComponent {
    constructor(private translate: TranslateService) {}

    public checkTranslationKeyExists(key: string) {
        const translation = this.translate.instant(key);
        return translation !== '' && translation !== key;
    }
}
